import React from "react";
import styled from "styled-components";
import { CardTableText, CardTableTextCard } from "src/components";
import Skeleton from "./Skeleton";

const SkeletonContainer = styled.div`
    margin: .5rem 1rem;
`;

const NoticeboardCard = (props) => {
    const { content, loading, cardType, ...otherProps } = props;

    return (
        <>
            <CardTableTextCard variant={cardType === "preview" ? "media" : undefined} {...otherProps}>
                {loading ?
                    <SkeletonContainer>
                        <Skeleton variant="Text" width="50px" height="33px" animation="wave" />
                    </SkeletonContainer>
                    : (cardType === "preview") ? props.children :
                        <CardTableText>{content}</CardTableText>
                }
            </CardTableTextCard>
        </>
    );
};
export default NoticeboardCard;
